
import RequestService from './request-service';
import { DateFilterService } from '@bto-services/utils';

export default class MyBetsRequestService extends RequestService {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.mybets;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';
    const { authorizationHeaders, defaultHeaders } = this.$config;

    /**
     * Set get params
     * @type {{}}
     */
    this.getParams = {
      page: 1,
      /**
       * @type {number[]}
       */
      status: [],
      items: 10,
      culture: defaultHeaders.Culture,
      TimeOffset: DateFilterService.utcTimeOffset(),
      // fromDate: '2019-08-04T22:00:00.000Z',
      // toDate: '2019-10-31T14:16:05.000Z'
    };
    this.headers = authorizationHeaders;
    // this.addHeader('Token', encodeURI(APP_SETTINGS.player.token));
    this.addHeader('ExternalUserID', APP_SETTINGS.player.id);
  }
}
